export default "__VITE_ASSET__CQWOQ8gj__"